import React from 'react';
import { Upload } from 'antd';
import { RcFile } from 'antd/lib/upload';

import './index.less';

const MAIN_CLASS_NAME = 'file-upload';
const BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__button`;

export interface IFileUploadProps {
  multiple: boolean;
  disabled: boolean;
  noButton?: boolean;
  accept?: string;
  sending?: boolean;
  onUpload?: (files: RcFile[]) => Promise<boolean | undefined>;
}

const FileUpload: React.FC<IFileUploadProps> = ({
  multiple = false,
  disabled = false,
  noButton = false,
  onUpload,
  accept = undefined,
  sending = false,
  children,
}) => {
  const beforeUpload = async (singleFile?: RcFile, multipleFiles?: RcFile[]) => {
    if (!onUpload) {
      return sending;
    }

    // NOTE: Upload component invokes event for every file, but we only react to last event which has UID for last file.
    if (multipleFiles?.length && !multipleFiles[multipleFiles.length - 1].uid) {
      return sending;
    }

    const selectedFiles = [];
    if (singleFile) {
      selectedFiles.push(singleFile);
    }
    if (multipleFiles?.length) {
      for (const multipleFile of multipleFiles) {
        if (singleFile && multipleFile.uid !== singleFile.uid) {
          selectedFiles.push(multipleFile);
        }
      }
    }

    if (!selectedFiles.length) {
      return sending;
    }

    const result = await onUpload(selectedFiles);
    return result === undefined ? sending : result;
  };

  return (
    <Upload accept={accept} beforeUpload={beforeUpload} className={MAIN_CLASS_NAME} fileList={[]} multiple={multiple}>
      {noButton ? (
        children
      ) : (
        <button className={BUTTON_CLASS_NAME} disabled={disabled}>
          {children}
        </button>
      )}
    </Upload>
  );
};

export default FileUpload;
